import {Button, Icon, Modal, Tooltip} from "antd";
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import {GenericButton} from "../../fields/GenericButton";
import React, {useContext, useEffect, useState} from "react";
import _ from "lodash";
import {GlobalStateContext} from "../../../context/GlobalStateProvider";
import {MDForm, FormContext} from "../../metadata/MDForm";
import {ApplicationExtendedAttributes} from "../ApplicationForm";
import {DeclaredComponent} from "../../DynamicComponent";
import {ModelContext} from "../../metadata/ModelSource";

export const CoverageItems = ({ coverageCd, items, option, ...props }) => {
  const [data, setData] = useState([]);
  const [detailsVisible, setDetailsVisible] = useState(false);
  const { isDesktop } = useContext(GlobalStateContext);
  const applicationModel = useContext(ModelContext);
  const formContext = useContext(FormContext);
  const [addNew, setAddNew] = useState(false);
  const [currentKey, setCurrentKey] = useState(null);

  const coveragePrefix =  `coverages{coverageCd:${coverageCd}}`;
  let coverageItems = applicationModel.getValue(`${option.prefix}${coveragePrefix}.coverageItems`);


  useEffect(() => {
    let addNewRow = false;
    if (!coverageItems) {
      coverageItems = [];
      setAddNew(true);
      addNewRow = true;
      setCurrentKey(0);
      applicationModel.setValue(`${option.prefix}${coveragePrefix}.coverageItems`, coverageItems);
    } else {
      setDetailsVisible(true);
    }
    const coverageItemRows = getFormContent(formContext, items, addNewRow, currentKey, isDesktop);
    setData(coverageItemRows);
  }, []);


  const addLabel = _.get(option, "productScheduledLocations") ? 'Add Location' : 'Add Item';

  const saveCoverageItem = (itemKey) => {
    const itemPrefix = getCoveragePrefix(itemKey);
    const coverageItem = formContext.getValue(`${itemPrefix}`);
    coverageItem.status = 'Active';
    setCurrentKey(null);
    const coverageItemRows = getFormContent(formContext, items, false, null, isDesktop);
    setData(coverageItemRows);
  };

  const cancelEdit = (itemKey) => {
    setCurrentKey(null);
    setAddNew(false);
    const coverageItemRows = getFormContent(formContext, items, false, null, isDesktop);
    setData(coverageItemRows);
  };

  const editCoverageItem = (itemKey) => {
    setCurrentKey(itemKey);
    const coverageItemRows = getFormContent(formContext, items, false, itemKey, isDesktop);
    setData(coverageItemRows);
  };

  const deleteCoverageItem = (itemKey) => {
    const itemPrefix = getCoveragePrefix(itemKey);
    const coverageItem = formContext.getValue(`${itemPrefix}`);
    if (!coverageItem.id) {
      coverageItems.splice(itemKey,1);
    } else {
      coverageItem.status = 'Deleted';
    }
    setCurrentKey(null);
    const coverageItemRows = getFormContent(formContext, items, false, itemKey, isDesktop);
    setData(coverageItemRows);
  };

  const disableSaveButton = (itemKey) => {
    const coverageNewPrefix = `coverageItems[${itemKey}]`;
    let allRequiredFilled = true;
    // Is this the current record that's being edited
    if (itemKey !== currentKey && addNew) {
      allRequiredFilled = false;
    } else {
      for (let index = 0; index < items.attributes.attributes.length; index++) {
        const isValid = evaluateRelationships(formContext, items.attributes.attributes[index]);
        if (!isValid) {
          continue;
        }
        if (!items.attributes.attributes[index].requiredInd) {
          continue;
        }
        const value = getAttributeMappingValue(formContext, coverageNewPrefix, items.attributes.attributes[index]);
        if (!value || value === '') {
          allRequiredFilled = false;
          break;
        }
      }
    }
    return !allRequiredFilled;
  };

  const disableCancelButton = (itemKey) => {
    return itemKey !== currentKey && addNew ? true : false;
  };

  const addItem = () => {
    setAddNew(true);
    const coverageItemRows = getFormContent(formContext, items, true, null, isDesktop);
    setData(coverageItemRows);
    setCurrentKey(coverageItemRows.length-1);
  };

  const RowAction = ({action, itemKey}) => {
    if (action === 'Edit') {
      return (
        <Row>
          <Col span={isDesktop ? 2 : 4}>
            <p style={{ fontWeight: 'bold' }}>Item</p>
          </Col>
          <Col span={isDesktop ? 2 : 4} >
            <Tooltip title={'Save'}>
              <Button icon={'check'}
                      type={'primary'}
                      className={'save-coverage-item-btn'}
                      onClick={() => saveCoverageItem(itemKey)}
                      disabled={disableSaveButton(itemKey)}
              />
            </Tooltip>
          </Col>
          <Col span={isDesktop ? 2 : 4} >
            <Tooltip title={'Cancel Edit'}>
              <Button className={'cancel-edit-coverage-item-btn'}
                      onClick={() => cancelEdit(itemKey)}
                      icon={'close'}
                      type={'secondary'}
              />
            </Tooltip>
          </Col>
        </Row>
      );
    }
    return (
      <Row>
        <Col span={isDesktop ? 2 : 4}>
          <p style={{ fontWeight: 'bold' }}>Item</p>
        </Col>
        <Col span={isDesktop ? 2 : 4} >
          <Tooltip title={'Edit'}>
            <Button icon={'edit'}
                    type={'primary'}
                    className={'save-coverage-item-btn'}
                    onClick={() => editCoverageItem(itemKey)}
                    disabled={disableSaveButton(itemKey)}
            />
          </Tooltip>
        </Col>
        <Col span={isDesktop ? 2 : 4} >
          <Tooltip title={'Delete'}>
            <Button className={'delete-coverage-item-btn'}
                    onClick={() => deleteCoverageItem(itemKey)}
                    disabled={disableCancelButton(itemKey)}
                    icon={'delete'}
                    type={'secondary'}
            />
          </Tooltip>
        </Col>
      </Row>
    );
  };

  return (
    <div>
      {detailsVisible ? (
        <div>
          <Row style={{ display: 'flex', width: '100%', margin: '0px 0' }}>
            <Col span={isDesktop ? 16 : 20}>
              <p style={{ fontWeight: 'bold' }}>Item List</p>
            </Col>
            <Col>
              <Button className={'add-coverage-item-btn'}
                      onClick={() => addItem()}
                      disabled={currentKey !== null}
                      icon={'plus'}
                      type={'secondary'}
              />
            </Col>
          </Row>
          {data.map((row, index) => (
              <div>
                <RowAction action={row.editInd ? 'Edit' : ''} itemKey={index}/>
                <Row style={{ display: 'flex', width: '100%', margin: '0px 0' }}>
                  <Col span={isDesktop ? 16 : 20}>
                    <CoverageItemRow model={applicationModel} setupContext={items} prefix={row.prefix} form={row.form} attributes={ApplicationExtendedAttributes} />
                  </Col>
                </Row>
              </div>
          ))}
        </div>
      ) : (
        <div>
          <GenericButton
              icon='plus'
              label={addLabel}
              onClick={() => setDetailsVisible(true)}
              type='primary'
          />
        </div>
      )}
    </div>
  );

}

const CoverageItemRow = ({model, setupContext, prefix, form, attributes}) => {
  return (
      <MDForm
          model={model}
          productSetupContext={setupContext}
          prefix={prefix}
          presentationMetadata={form}
          extendedAttributes={attributes}
      >
        <DeclaredComponent declaration={form} />
      </MDForm>
  );
};

function getCoveragePrefix(count) {
  return `coverageItems[${count}]`;
}

function getCoverageItems(formContext) {
  const coverageItems = formContext.getValue('coverageItems');
  if (!coverageItems) {
    return null;
  }
  for (let i=0; i<coverageItems.length; i++) {
    if (coverageItems[i].status !== 'Active' && coverageItems.id === '') {
      coverageItems.splice(i,1);
      i--;
    }
  }
  return coverageItems.filter(item => item.status === 'Active');
}

function getInputContent(items, index) {
  const inputContent = items.attributes.attributes.map((attribute) => {
    if (attribute.dataType === 'Address') {
      return { Field: {attr: attribute.id, metadata: attribute, showCheckbox: false, nestedCoverage: true, showTopLabel: true, component: { VerifiedAddress: { singleAttributeAddress: {attr: attribute.id}}}}};
    }
    if (attribute.productListConstraint === 'ProductScheduledItem.ClassCd') {
      return { Field: {attr: attribute.id, metadata: attribute, dataType: 'SelectScheduledItem', showCheckbox: false, nestedCoverage: true, showTopLabel: true }};
    }
    return { Field: {attr: attribute.id, metadata: attribute, showCheckbox: false, nestedCoverage: true, showTopLabel: true }};
  });
  const prefix = `coverageItems[${index}]`;
  return {form: { Group: { content: inputContent}}, prefix: prefix, editInd: true};
}

function getDisplayContent(items, formContext, index, isDesktop) {
  const prefix = `coverageItems[${index}]`;
  let displayContent = [];
  if (isDesktop) {
    displayContent = items.attributes.attributes.map((attribute) => {
      let value = getAttributeMappingValue(formContext, prefix, attribute);
      if (attribute.productListConstraint === 'ProductScheduledItem.ClassCd') {
        value = getScheduledItemCodeDescription(items, value);
      }
      if (!value) {
        value = '';
      }
      return { Expression : {value: `${attribute.label} : ${value}`, style: { display: 'flex',marginBottom: '12px',color: 'rgba(0, 0, 0, 0.85)',}, }};
    });
  } else {
    for (let i=0; i<items.attributes.attributes.length; i++) {
      const attribute = items.attributes.attributes[i];
      let value = getAttributeMappingValue(formContext, prefix, attribute);
      if (attribute.productListConstraint === 'ProductScheduledItem.ClassCd') {
        value = getScheduledItemCodeDescription(items, value);
      }
      if (!value) {
        value = '';
      }
      displayContent.push({ Expression : {value: `${attribute.label} :`, style: { display: 'flex',marginBottom: '12px',color: 'rgba(0, 0, 0, 0.85)',}, }});
      displayContent.push({ Expression : {value: `${value}`, style: { display: 'flex',marginBottom: '12px', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.85)',}, }});
    }
  }
  return {form: { Group: { content: displayContent}}, index: prefix, editInd: false};
}

function getFormContent(formContext, items, addNewItem, currentKey, isDesktop) {
  const coverageItems = getCoverageItems(formContext);
  let content = coverageItems ? coverageItems.map((item, index) => {
    if (currentKey !== null && currentKey === index) {
      return getInputContent(items, index);
    } else {
      return getDisplayContent(items, formContext, index, isDesktop);
    }
  }) : [];
  if (addNewItem) {
    content.push(getInputContent(items, content.length));
  }
  return content;
}

function getAttributeMappingValue(formContext, prefix, attribute) {
  const mappings = attribute.attributeMappings;
  const dataType = attribute.dataType;
  const apiMapping = mappings.find(am => am.typeCd === 'API');
  const objectOrValue = formContext.getValue(`${prefix}.${apiMapping.mapping}`);
  if (objectOrValue && dataType === 'Address') {
    return `${objectOrValue.addr1} ${objectOrValue.city} ${objectOrValue.stateProvCd} ${objectOrValue.postalCode}`;
  } else {
    return objectOrValue;
  }
}

function evaluateRelationships(formContext, attr) {
  if (attr.attributeRelationships) {
    for (let attrRel of attr.attributeRelationships) {
      if (attrRel.typeCd === 'ApplicableIf' && attrRel.attributeConditions) {
        if (!formContext.evalConditions(attrRel.attributeConditions)) {
          return false;
        }
      }
    }
  }
  return true;
}

function getScheduledItemCodeDescription(item, value) {
  const productItem = item.productScheduledItem.find((v) => v.classCd === value);
  if (productItem) {
    return productItem.shortDesc;
  }
  return null;
}